import _ from "lodash";
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const FavoriteTreatmentUtils = {
  setTtl: (key) => {
    localStorage.setItem(`${key}_timestamp`, Date.now().toString());
  },

  getTtl: (key) => {
    const cacheTimestamp = localStorage.getItem(`${key}_timestamp`);
    if (!cacheTimestamp) return null;
    return Date.now() - parseInt(cacheTimestamp) < CACHE_TTL;
  },

  getCachedFavorites: () => {
    const cached = localStorage.getItem("favourites");
    if (!cached) return null;
    return JSON.parse(cached);
  },
  setCachedFavorites: (favourites) => {
    localStorage.setItem("favourites", JSON.stringify(favourites));
  },
  getSpecialityCode: () => {
    return localStorage.getItem("specialityCode");
  },

  getSelectedCodes: (favoritesData) => {
    const codes = [];
    _.forEach(favoritesData, (item, index) => {
      if (item.selected) {
        codes.push(index);
      }
    });
    return codes;
  },
};

export default FavoriteTreatmentUtils;
